<i18n>
{
  "fr": {
    "elevationProfil-label": "Coupe (c)"
  },
  "de": {

  }
}
</i18n>


<template>
  <div :class="['interaction-button', state]" @click="toggleState" @keyup.67="toggleState">
    <md-icon>show_chart</md-icon>
    <md-tooltip md-direction="right">{{ $t('elevationProfil-label') }}</md-tooltip>
  </div>
</template>

<script>

import InteractionMixin from '@/mixins/store/interaction'
import MapMixin from '@/mixins/store/map'
import GeoJSON from '@/utils/geoJson'
import { get as getProjection } from 'ol/proj'
import { Fill, Stroke, Style, Circle } from 'ol/style'
import { Feature } from 'ol'
import Config from '@/config.js'

export default {
  name: 'ElevationProfilButton',
  mixins: [
    InteractionMixin,
    MapMixin
  ],
  data () {
    return {
      state: 'disable',
      profilFeature: null,
      beginPointFeature: null,
      endPointFeature: null
    }
  },
  watch: {
    state (val) {
      if (val === 'focus') return this.init()
      if (val === 'disable') return this.clear()
    }
  },
  destroyed () {
    if (this.elevationProfilInteraction !== null) this.elevationProfilInteraction.release()
    this.vectorClickInteraction.enable()
  },
  methods: {
    init () {
      this.initElevationProfilInteraction(this.mapRef)
      this.elevationProfilInteraction.onFeaturesChange(this.onDrawEnd)
      this.vectorClickInteraction.disable()
    },
    clear () {
      if (this.elevationProfilInteraction !== null) this.elevationProfilInteraction.release()
      this.setCurrentGeom(null)
      this.clearHoverFeature()
      this.vectorClickInteraction.enable()
    },
    toggleState (){
      if (this.state === 'disable') return this.state = 'focus'
      if (this.state === 'focus') return this.state = 'disable'
      if (this.state === 'enable') return this.state = 'focus'
    },
    onDrawEnd (event, geom) {
      this.state = 'enable'
      this.elevationProfilInteraction.clearDrawLayer()
      this.elevationProfilInteraction.release()

      // La géométrie reçue est au format GeoJSON
      // Création de géométries pour openlayers
      let profilGeom = GeoJSON.readGeometry(geom, {
        dataProjection: getProjection(Config.mapConfiguration.projection),
        featureProjection: getProjection(Config.mapConfiguration.projection)
      })

      let beginPointGeom = GeoJSON.readGeometry({
        coordinates: geom.coordinates[0],
        type: 'Point'
      }, {
        dataProjection: getProjection(Config.mapConfiguration.projection),
        featureProjection: getProjection(Config.mapConfiguration.projection)
      })

      let endPointGeom = GeoJSON.readGeometry({
        coordinates: geom.coordinates[1],
        type: 'Point'
      }, {
        dataProjection: getProjection(Config.mapConfiguration.projection),
        featureProjection: getProjection(Config.mapConfiguration.projection)
      })


      this.clearHoverFeature()

      // Création des features à afficher sur la carte
      this.profilFeature = new Feature(profilGeom)
      this.profilFeature.setStyle([
        new Style({
          stroke: new Stroke({
            color: 'white',
            width: 5,
            zIndex: 0
          })
        }),
        new Style({
          stroke: new Stroke({
            color: '#60b0f5',
            width: 3,
            zIndex: 1
          })
        })
      ])
      this.addHoverFeature(this.profilFeature)

      this.beginPointFeature = new Feature(beginPointGeom)
      this.beginPointFeature.setStyle(new Style({
        image: new Circle({
          radius: 6,
          fill: new Fill({
            color: '#85c110'
          }),
          stroke: new Stroke({
            color: 'white'
          }),
        })
      }))
      this.addHoverFeature(this.beginPointFeature)

      this.endPointFeature = new Feature(endPointGeom)
      this.endPointFeature.setStyle(new Style({
        image: new Circle({
          radius: 6,
          fill: new Fill({
            color: '#c11010'
          }),
          stroke: new Stroke({
            color: 'white'
          }),
        })
      }))
      this.addHoverFeature(this.endPointFeature)
      this.setCurrentGeom(geom)
      setTimeout(() => this.vectorClickInteraction.enable(), 500)
    }
  }
}
</script>

<style lang="scss">
  .interaction-button {

    &.focus {
      background-color: #184aa0 !important;
      .md-icon {
        color: white !important;
      }
    }

    &.enable {
      background-color: #4d86e8 !important;
      .md-icon {
        color: white !important;
      }
    }

  }
</style>
